export enum WorkflowPublishCategoryType {
  OveridePublish = 'HAS_PREFILLED_FORM_URL_TO_PUBLISH',
  OverideUnpublish = 'HAS_PREFILLED_FORM_URL_TO_UNPUBLISH',
  RegularPublish = 'HAS_NO_PREFILLED_FORM_URL_TO_PUBLISH',
  RegularUnpublish = 'HAS_NO_PREFILLED_FORM_URL_TO_UNPUBLISH',
}
